<section class="container">
    <div class="login-section">
        <div class="login-header">
            <img src="assets/icons/seller-logo.png" class="app-logo" alt="app-logo" />
        </div>
        <div class="welcome-part">
            <h4 class="welcome-title">إعادة تعيين كلمة المرور</h4>
            <p class="welcome-paragraph" *ngIf="email">أدخل كلمة المرور الجديدة لحساب: {{ email }}</p>
            <p class="welcome-paragraph" *ngIf="!email">أدخل كلمة المرور الجديدة</p>
        </div>
        <div class="credentials-part col-md-6">
            <form [formGroup]="form" (ngSubmit)="resetPassword()" *ngIf="!isSuccess">
                <!-- NEW PASSWORD -->
                <div class="d-flex flex-column gap-2 mb-3">
                    <label for="password">كلمة المرور الجديدة</label>
                    <input
                        formControlName="password"
                        pInputText
                        id="password"
                        autocomplete="new-password"
                        type="password"
                        class="p-inputtext-sm"
                        aria-describedby="password-help" />
                    <small *ngIf="form.get('password')?.invalid && form.get('password')?.touched" class="text-danger">
                        كلمة المرور يجب أن تكون على الأقل 6 أحرف
                    </small>
                </div>
                
                <!-- CONFIRM PASSWORD -->
                <div class="d-flex flex-column gap-2 mb-4">
                    <label for="confirmPassword">تأكيد كلمة المرور</label>
                    <input
                        formControlName="confirmPassword"
                        pInputText
                        id="confirmPassword"
                        autocomplete="new-password"
                        type="password"
                        class="p-inputtext-sm"
                        aria-describedby="confirmPassword-help" />
                    <small *ngIf="passwordMismatch" class="text-danger">
                        كلمات المرور غير متطابقة
                    </small>
                </div>
                
                <div class="text-center my-2" [ngClass]="{'text-danger': !isSuccess, 'text-success': isSuccess}">
                    {{ message }}
                </div>
                
                <div class="submit-form full-width">
                    <p-button
                        [disabled]="form.invalid || resetInProgress"
                        type="submit"
                        label="إعادة تعيين كلمة المرور"
                        class="w-100"
                        [icon]="resetInProgress ? 'pi pi-spin pi-spinner' : ''"></p-button>
                </div>
            </form>
            
            <!-- SUCCESS MESSAGE -->
            <div *ngIf="isSuccess" class="text-center">
                <div class="text-center my-4">
                    <i class="pi pi-check-circle text-success" style="font-size: 3rem;"></i>
                </div>
                <div class="text-center my-2 text-success">
                    {{ message }}
                </div>
                <p class="text-muted">سيتم توجيهك إلى صفحة تسجيل الدخول خلال ثوانٍ قليلة...</p>
            </div>
            
            <!-- BACK TO LOGIN -->
            <div class="register-redirection" *ngIf="!isSuccess">
                <small>تذكرت كلمة المرور؟ <a class="m-1 text-primary-600" routerLink="/auth/login">تسجيل الدخول</a></small>
            </div>
        </div>
    </div>
</section>
